'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VXFilters = exports.Filters = undefined;

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withFilters = require('./with-filters');

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Filters = function Filters(_ref) {
  var items = _ref.items,
      isRtl = _ref.isRtl,
      filters = _ref.filters,
      onChangeActiveFilter = _ref.onChangeActiveFilter,
      rest = _objectWithoutProperties(_ref, ['items', 'isRtl', 'filters', 'onChangeActiveFilter']);

  return _react2.default.createElement(
    _react.Fragment,
    null,
    (0, _map2.default)(function (item) {
      return _react2.default.createElement(_.VXFilter, _extends({
        key: item.id,
        id: item.id,
        items: item.values,
        titleLabel: item.label,
        isOpenDry: true,
        isRtl: isRtl,
        isOpen: filters.activeFilterId === item.id,
        changeIsOpen: onChangeActiveFilter(item.id)
      }, rest));
    })(items)
  );
};

exports.Filters = Filters;
Filters.propTypes = {
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string,
    values: _propTypes2.default.array
  })),
  changeActiveFilter: _propTypes2.default.func,
  onChangeActiveFilter: _propTypes2.default.func.isRequired,
  isRtl: _propTypes2.default.bool
};

var VXFilters = exports.VXFilters = (0, _withFilters.withFilters)(Filters);


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-filters/index.js
// module id = 2034
// module chunks = 0